import { Component, Input, Output, EventEmitter } from '@angular/core';

import { IPayableModel } from './../../models/payable.models';

@Component({
    selector: 'payable-list',
    templateUrl: './payableList.template.html',
    host: {'class': 'payable-list-component', id: 'sidebar-content'}
})

export class PayableListComponent {
    @Input()
    model: Array<IPayableModel> = new Array<IPayableModel>();

    @Input()
    selectedPayableId: string = null;

    @Input()
	showIndicator: boolean = false;

    @Output()
    onPayableSelect: EventEmitter<IPayableModel> = new EventEmitter<IPayableModel>();

    selectPayable(payable: IPayableModel): void {
        this.onPayableSelect.emit(payable);
    }
}
